import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';

// Rxjs
import { Observable } from 'rxjs/Observable';

// Reducers & Actions
import * as Account from '../../../my-account/actions/account.actions';
import * as fromCore from '../../../core/reducers';
import * as fromAuth from '../../../auth/reducers';

// Services
import { TranslationService } from '../../../translation/services/translation.service';

@Component({
  selector: 'license-modal',
  templateUrl: './license-modal.component.html',
  styleUrls: ['./license-modal.component.scss']
})
export class LicenseModalComponent implements OnInit {

  // Should show
  @Input() show: boolean = false;
  @Input() canDecline: boolean = true;

  // Public variables
  public langPickerOpened: boolean = false;
  public currentLicenseLang;

  // Observables
  public userInformation$: Observable<any> = this.authStore.select(state => state.auth.login.user);
  public acceptingLicense$: Observable<boolean> = this.coreStore.select(state => state.core.account.acceptingLicense);
  public licenseAgreement$: Observable<string> = this.coreStore.select(state => state.core.account.licenseAgreement);
  public declinedModalOpened$: Observable<boolean> = this.coreStore.select(state => state.core.account.licenseDeclinedModalOpened);

  // Construcotr
  constructor(
    private router: Router,
    private authStore: Store<fromAuth.State>,
    private coreStore: Store<fromCore.State>,
    private translationService: TranslationService
  ) { }

  // On component init
  ngOnInit() {
    // Getting license language by default (English)
    this.currentLicenseLang = this.translationService.langsAvailable[0];
    this.coreStore.dispatch(new Account.GetLicenseAgreement(this.currentLicenseLang.code));
  }

  // Get languages availables
  public get languagesAvailable(): Array<any> {
    return this.translationService.langsAvailable;
  }

  // Toggle license agreement modal
  public toggleLicenseModal(): void {
    this.coreStore.dispatch(new Account.ToggleLicenseModal());
  }

  // Close declined license modal
  public closeDeclinedModal(): void {
    this.coreStore.dispatch(new Account.CloseDeclinedLicenseModal());
  }

  // Toggle lang picker dropdown
  public toggleLangPicker(): void {
    this.langPickerOpened = !this.langPickerOpened;
  }

  // Change license language
  public changeLicenseLang(lang): void {
    // Toggle lang picker
    this.toggleLangPicker();
    // Save new lang
    this.currentLicenseLang = lang;
    // Get the new license
    this.coreStore.dispatch(new Account.GetLicenseAgreement(this.currentLicenseLang.code));
  }

  // Accepting license
  public acceptLicense(): void {
    this.coreStore.dispatch(new Account.LicenseAgreement(1));
  }

  // Decline license
  public declineLicense(): void {
    this.coreStore.dispatch(new Account.LicenseAgreement(0));
    this.coreStore.dispatch(new Account.DeclineLicense());
  }

  // Go to my account
  public goToMyAccount(): void {
    this.closeDeclinedModal();
    this.router.navigateByUrl('/admin/my-account');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/license-modal/license-modal.component.ts